module.exports = '3.9.1';
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/version.js
// module id = 1282
// module chunks = 0